var _defs, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _path2, _path3, _path4, _path5, _path6, _path7, _g8, _g9, _g10, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g11, _g12, _g13, _g14, _g15, _g16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaveMountainPanorama(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4000 445",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1833.14 398.63l-1.96-64.5-22.47-20.52-20.52-4.88-43 .97-35.18-1.95-11.73-4.89-9.77-7.82-39.09-2.93-29.56-13.92-7.33 10.26-18.32 3.66-21.99 1.47-14.65 5.86-30.05 8.06-19.79-1.46h-10.26l-5.86 3.66-12.46-1.46-10.34-.55-.01-.43-72.88-22.23-32.25 2.2-31.51-15.39-35.18-3.67-17.59-10.99h-11.73l-2.93-.73-5.13-5.87-5.8-2.87-5.76-19.58-22.66-5.66-17.94-4.72-11.33-4.72-15.1 5.66-12.27 6.61-26.44 7.55-9.44 16.05-31.85 7.55-2.14 6.62-28.32-.95-11 8.52-10.29 1.2-24.19 5.13-30.78-1.47-26.38-10.99-25.66-9.53h-33.71l-14.66-11.73-18.32-7.33-13.93-5.13-10.99-7.33-21.99-3.66-27.85-12.95-15.06 2.2-16.86-7.33h-19.79l-19.38 7.82-19.79 1.47-15.39-4.89-15.39 8.55-24.18 5.13h-2.2l-12.14-9.28-13.19 1.95-16.61-11.73L584.44 190l-14.17-5.87-28.18-5.37-13.19-8.06-18.41 6.27-31.84-8.23-22.31 4.15-18.32 8.8-29.32 5.86-5.86 5.13-27.85 14.66-5.87 13.93-19.78 7.32-13.2 8.07-12.46 8.79-14.65 9.53-21.99 18.32.33 147.31h1182.41l-.33-38.16 363.69 16.18z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1589.19 318.75l.35 1.71h-1.44v-1.71h1.09z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1587.02 318.75l-.35 1.71h1.43v-1.71h-1.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1588.1 309.98l-6.85 9.37 4.48-1.15 2.37 1.02v-9.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1588.1 306.94l-5.77 7.89 3.77-.96 2 .85v-7.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1588.1 304.87l-4.3 5.89 2.81-.72 1.49.64v-5.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1588.1 309.98l6.86 9.37-4.48-1.15-2.38 1.02v-9.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1588.1 306.94l5.78 7.9-3.78-.97-2 .86v-7.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1588.1 304.88l4.31 5.88-2.81-.72-1.5.64v-5.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1092.28 281.62l.35 1.7h-1.43v-1.7h1.08z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090.11 281.62l-.35 1.7h1.44v-1.7h-1.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1091.2 272.85l-6.86 9.36 4.48-1.14 2.38 1.01v-9.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1091.2 269.81l-5.78 7.89 3.78-.97 2 .86v-7.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1091.2 267.74l-4.31 5.89 2.81-.72 1.5.63v-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1091.2 272.85l6.85 9.36-4.48-1.14-2.37 1.02v-9.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1091.2 269.81l5.77 7.89-3.77-.96-2 .85v-7.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1091.2 267.74l4.3 5.89-2.81-.72-1.49.64v-5.81z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1004.99 293.67l.34 1.71h-1.43v-1.71h1.09z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.81 293.67l-.35 1.71h1.44v-1.71h-1.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1003.9 284.9l-6.86 9.36 4.49-1.14 2.37 1.02v-9.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1003.9 281.86l-5.78 7.89 3.78-.96 2 .85v-7.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1003.9 279.79l-4.31 5.89 2.82-.72 1.49.64v-5.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1003.9 284.9l6.85 9.37-4.48-1.15-2.37 1.02v-9.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1003.9 281.86l5.78 7.89-3.78-.96-2 .86v-7.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1003.9 279.79l4.31 5.89-2.82-.72-1.49.64v-5.81z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1285.77 295.32l.35 1.71h-1.44v-1.71h1.09z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283.59 295.32l-.34 1.71h1.43v-1.71h-1.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1284.68 286.55l-6.85 9.37 4.48-1.15 2.37 1.02v-9.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1284.68 283.51l-5.77 7.9 3.77-.97 2 .86v-7.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1284.68 281.45l-4.31 5.88 2.82-.72 1.49.64v-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1284.68 286.55l6.86 9.37-4.49-1.15-2.37 1.02v-9.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1284.68 283.52l5.78 7.89-3.78-.97-2 .86v-7.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1284.68 281.45l4.31 5.88-2.82-.72-1.49.64v-5.8z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1048.89 294.29l.35 1.71h-1.44v-1.71h1.09z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.71 294.29l-.34 1.71h1.43v-1.71h-1.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1047.8 285.52l-6.85 9.37 4.48-1.15 2.37 1.02v-9.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1047.8 282.48l-5.77 7.89 3.77-.96 2 .86v-7.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1047.8 280.41l-4.3 5.89 2.81-.72 1.49.64v-5.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1047.8 285.52l6.86 9.37-4.48-1.15-2.38 1.02v-9.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1047.8 282.48l5.78 7.9-3.78-.97-2 .86v-7.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1047.8 280.42l4.31 5.88-2.82-.72-1.49.64v-5.8z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1248.88 297.48l.35 1.71h-1.44v-1.71h1.09z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.7 297.48l-.34 1.71h1.43v-1.71h-1.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1247.79 288.71l-6.85 9.37 4.48-1.15 2.37 1.02v-9.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1247.79 285.67l-5.77 7.89 3.77-.96 2 .85v-7.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1247.79 283.6l-4.31 5.89 2.82-.72 1.49.64v-5.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1247.79 288.71l6.86 9.37-4.48-1.15-2.38 1.02v-9.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1247.79 285.67l5.78 7.9-3.78-.97-2 .86v-7.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1247.79 283.61l4.31 5.88-2.82-.72-1.49.64v-5.8z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1233.8 298.16l.29 1.48h-1.23v-1.48h.94z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.92 298.16l-.3 1.48h1.24v-1.48h-.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1232.86 290.6l-5.91 8.08 3.86-.99 2.05.88v-7.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1232.86 287.98l-4.98 6.81 3.25-.84 1.73.74v-6.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1232.86 286.2l-3.72 5.07 2.43-.62 1.29.55v-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1232.86 290.6l5.91 8.08-3.87-.99-2.04.88v-7.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1232.86 287.98l4.98 6.81-3.26-.83-1.72.73v-6.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1232.86 286.2l3.71 5.07-2.43-.62-1.28.55v-5z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1669.7 325.83c-60.1-5.38-150-18.57-150-18.57l-7.82-9.77-8.79-2.44-7.33-8.31-7.9-4.14-.25-1.24-7.82-10.75 2.93-15.64-25.41-11.73-4.89-7.82-8.79-2.93-20.52 4.89-4.89 6.84-10.75 6.84-2.93 11.73-6.84 3.91-5.86 6.84s-24.92 12.21-97.23 19.06c-72.31 6.84-76.96 4.64-76.96 4.64l-12.46-17.83-14.66-2.93-19.54 14.17-12.87 4.56-9.94 15.64h-5.7l-2.77-10.67-13.68-17.83-6.84-5.86h-13.68l-3.91 3.91h-18.57l-10.75 11.73s-36.16 1.95-72.31-.98c-36.16-2.93-135.99-37.13-135.99-37.13l-14.66-10.75-29.97-.65-21.5 8.14-17.92-12.05-12.05-5.21-23.45-2.93-14.66 8.14-12.7 5.21-19.87 2.28-18.57 14.66-30.29 10.75-21.5.33-38.11 28.01 17.26 109.69h879.48l360.59-32.49 15.64-42.02s-131.92-3.91-192.02-9.28z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1139.79 363.46s11.47-3.18 25.75 3.12c14.28 6.3 44.58 18.61 58.42 16.56 13.84-2.05 24.12-5.88 41.53-10.14 17.41-4.27 39.89-4.86 53.9-2.01 14.02 2.86 81.32 15.18 81.32 15.18l160.59-12.7s-147.56-21.82-258.5-25c-44.5-.9-60.96 19.1-87.26 16.92-26.3-2.18-41.06-16.34-64.13-15.38-23.07.97-104.45 15.32-104.45 15.32l28.99 4.23 63.83-6.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M4000.44 284.93s-78.86-.86-202.66 7.98c-139.67 9.98-337.04 46.4-417.7 55.11l-.3.03h-.11l-10.49 1.14c-82.36 8.91-172.61 16.04-256.29 21.2-49.78 3.07-99.73 5.45-148.45 7.07-53.74 1.79-107.2 2.7-158.91 2.7-30.6 0-61.23-.32-91.04-.95-31.14-.65-62.23-1.67-92.41-3.01-31.49-1.4-62.83-3.19-93.14-5.33-31.57-2.22-62.94-4.88-93.22-7.9-66.75-6.65-135.7-12.95-204.94-18.71-64.48-5.38-189.04-13.24-238.65-15.04-47.64-2.12-97.99 0-97.99 0-33.1 1.79-116.18 9.65-159.21 15.03-46.18 5.77-92.19 12.06-136.71 18.71-20.21 3.02-41.13 5.68-62.19 7.91-20.23 2.13-41.14 3.93-62.14 5.33-20.13 1.34-40.88 2.35-61.65 3-19.89.63-40.32.95-60.73.95-34.49 0-70.17-.91-106.01-2.7-32.5-1.62-65.82-4-99.03-7.07-55.82-5.16-111.98-12.29-166.92-21.2l-6.99-1.13h-.08l-.2-.04c-53.8-8.71-114.78-18.57-177.52-28.25-72.23-11.14-135.15-20.24-192.36-27.81-33.44-4.42-65.5-8.39-95.27-11.8-32.3-3.69-63.02-6.85-91.29-9.38-30.32-2.71-58.83-4.79-84.73-6.19-27.54-1.48-53-2.24-75.64-2.24-24.05 0-45.66.85-64.27 2.51a708.474 708.474 0 00-35.48 4.1 680.417 680.417 0 00-33.99 5.72 661.741 661.741 0 00-63.56 15.7c-18.05 5.44-37.57 12.35-55.08 19.35l-.17 137.46 1930.33-1h.13l2067.03.71.03-161.97z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1391.79 379.5l-3.22-7.78-5.56 7.73-4.16-8.03-4.99 7.98-3.7-8.26-5 8.36-3.06-9.03-4.66 9.23-2.19-9.57-5.8 8.54-1.49-9.1-7.44 8.29-2.6-8.72-7.21 7.17-3.69-8.67-5.63 7.15-1.75-7.88-6.49 6.54-1.7-7.29-7.07 6.48-1.06-7.75-5.23 6.33-2.19-7.53-5.01 6.29-1.06-7.28-6.15 6.15-.19-6.59-5.1 5.68-1.21-7.44-5.54 6.16-1.22-7.31-5.48 5.78-1.84-7.18-4.79 5.69-.37-6.84-4.47 4.29-.46-5.56-4.76 4.24.01-5.87-5.51 4.96-.5-6.24-4.62 3.74.04-5.32-4.85 3.35-.09-4.82-5.01 2.85-.41-4.66-3.61 3.15-.23-4.29-3.6 2.8-.25-4.53-3.93 2.28.04-3.77-3.45 2.28-.77-3.71-2.89 1.94-.91-3.73-2.83 2.61-.38-3.79-3.51 2.09-.2-3.77-3.69 2.06.3-3.57-3.36 2.04.15-3.56-3.82 1.7.4-3.13-3.69 1.6.47-2.95-3.06 1.61-.18-3.41-3.43 1.41-.16-3.05-3.79 1.33-.5-3.42-3.13 1.44.01-2.86-2.67.88.1-2.72-3.65 1.09-.04-2.3-3.39-.06-.21-2.44-2.6 1.44-.33-3.2-2.67 1.64-.07-3.08-4.59.59.75-2.53-3.06.55.17-2.57-3.23 1.18.84-4.35.99.19-.51 2.62 3.01-1.11-.19 2.83 3.4-.61-.77 2.61 4.16-.54.06 2.46 2.54-1.57.34 3.28 2.63-1.45.26 3.08 3.46.06.03 1.94 3.72-1.1-.09 2.67 2.62-.87-.02 2.69 2.92-1.34.52 3.54 3.9-1.37.16 2.97 3.43-1.41.18 3.26 3.45-1.83-.51 3.14 3.64-1.57-.4 3.1 3.66-1.63-.13 3.31 3.43-2.09-.3 3.65 3.45-1.92.2 3.72 3.44-2.05.33 3.36 2.61-2.41.97 3.99 2.94-1.96.77 3.71 3.79-2.51-.04 3.9 3.82-2.22.23 4.26 3.6-2.81.23 4.16 3.55-3.1.44 5.07 5.12-2.91.09 4.64 4.9-3.38-.04 5.12 4.44-3.6.49 6.11 5.69-5.1-.01 5.87 4.58-4.09.46 5.48 4.52-4.35.35 6.49 4.41-5.24 1.88 7.31 5.62-5.92 1.2 7.24 5.55-6.17 1.21 7.43 5.37-5.98.2 6.77 5.92-5.92 1.01 6.97 4.78-5.99 2.2 7.57 5.49-6.64 1.1 8.12 6.92-6.34 1.69 7.2 6.5-6.56 1.69 7.6 5.37-6.82 3.77 8.87 7.35-7.31 2.57 8.61 7.64-8.5 1.42 8.68 5.69-8.38 2.08 9.11 4.48-8.87 3.14 9.23 4.87-8.15 3.72 8.3 4.92-7.88 4.22 8.15 5.66-7.88 3.91 9.45-.93.38z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1142.52 310.86s50.09 34.99 103.94 53.62c45.43 13.38 65.83 14.97 65.83 14.97s49.23 1.1 79.73-.43c-14.25-.24-85.6-.48-159.92-26.82-68.03-27.66-83.86-41.38-83.86-41.38l-5.72.04z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1394.9 372.4c-.93 0-91.47-1.44-151.71-19.99-60.25-18.55-94.28-42.58-94.62-42.82l.58-.81c.34.24 30.18 22.29 90.26 40.8 60.1 18.51 156.58 19.45 157.5 19.46l-2.02 3.37z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1068.7 306.05l.54 2.68h-2.25v-2.68h1.71z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.29 306.05l-.54 2.68h2.24v-2.68h-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1066.99 292.32l-10.73 14.66 7.02-1.79 3.71 1.59v-14.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1066.99 287.56l-9.04 12.36 5.91-1.51 3.13 1.34v-12.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1066.99 284.32l-6.74 9.22 4.41-1.13 2.33 1v-9.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1066.99 292.32l10.73 14.67-7.01-1.8-3.72 1.59v-14.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1066.99 287.56l9.04 12.36-5.91-1.51-3.13 1.34v-12.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1066.99 284.33l6.75 9.21-4.41-1.13-2.34 1v-9.08z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1020.88 300.49l.54 2.67h-2.25v-2.67h1.71z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.47 300.49l-.54 2.67h2.24v-2.67h-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1019.17 286.76l-10.73 14.66 7.02-1.79 3.71 1.59v-14.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1019.17 282l-9.04 12.35 5.91-1.51 3.13 1.34V282z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1019.17 278.76l-6.74 9.21 4.41-1.12 2.33 1v-9.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1019.17 286.76l10.74 14.66-7.02-1.79-3.72 1.59v-14.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1019.17 282l9.05 12.36-5.92-1.51-3.13 1.34V282z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1019.17 278.76l6.75 9.22-4.41-1.13-2.34 1v-9.09z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1309.06 300.3l.54 2.67h-2.25v-2.67h1.71z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1305.65 300.3l-.54 2.67h2.24v-2.67h-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1307.35 286.57l-10.73 14.66 7.02-1.79 3.71 1.59v-14.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1307.35 281.81l-9.04 12.36 5.91-1.51 3.13 1.34v-12.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1307.35 278.57l-6.74 9.22 4.41-1.13 2.33 1v-9.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1307.35 286.57l10.73 14.67-7.01-1.8-3.72 1.59v-14.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1307.35 281.81l9.05 12.36-5.92-1.51-3.13 1.34v-12.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1307.35 278.57l6.75 9.22-4.41-1.13-2.34 1v-9.09z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M861.91 356.61l1.24 6.11h-5.13v-6.11h3.89z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M854.12 356.61l-1.24 6.11h5.14v-6.11h-3.9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M858.02 325.2l-24.55 33.54 16.05-4.1 8.5 3.64V325.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M858.02 314.32l-20.69 28.26 13.53-3.46 7.16 3.07v-27.87z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M858.02 306.91l-15.43 21.08 10.09-2.58 5.34 2.29v-20.79z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M858.02 325.21l24.54 33.54-16.05-4.11-8.49 3.64v-33.07z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M858.02 314.32l20.68 28.27-13.52-3.46-7.16 3.07v-27.88z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M858.02 306.92L873.44 328l-10.08-2.58-5.34 2.28v-20.78z"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M752.73 369.02l1.55 7.65h-6.42v-7.65h4.87z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.99 369.02l-1.55 7.65h6.42v-7.65h-4.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M747.86 329.77l-30.68 41.92 20.06-5.13 10.62 4.55v-41.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M747.86 316.17l-25.85 35.32 16.9-4.32 8.95 3.83v-34.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M747.86 306.91l-19.28 26.34 12.61-3.22 6.67 2.86v-25.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M747.86 329.78l30.68 41.92-20.06-5.13-10.62 4.55v-41.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M747.86 316.18l25.86 35.32-16.91-4.32-8.95 3.83v-34.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M747.86 306.92l19.28 26.34-12.6-3.22-6.68 2.86v-25.98z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1442.63 388.93l1.22 6.01h-5.05v-6.01h3.83z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1434.97 388.93l-1.22 6.01h5.05v-6.01h-3.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1438.8 358.06l-24.13 32.97 15.78-4.03 8.35 3.57v-32.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1438.8 347.37l-20.33 27.78 13.29-3.4 7.04 3.01v-27.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1438.8 340.08l-15.16 20.72 9.91-2.53 5.25 2.25v-20.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1438.8 358.07l24.13 32.97-15.78-4.04-8.35 3.58v-32.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1438.8 347.37l20.33 27.78-13.29-3.4-7.04 3.02v-27.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1438.8 340.09l15.16 20.72-9.91-2.53-5.25 2.24v-20.43z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1392.75 381.66l.76 3.79h-3.18v-3.79h2.42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.91 381.66l-.77 3.79h3.19v-3.79h-2.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1390.33 362.17l-15.23 20.81 9.96-2.55 5.27 2.26v-20.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1390.33 355.42l-12.83 17.54 8.39-2.15 4.44 1.9v-17.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1390.33 350.83l-9.57 13.07 6.25-1.6 3.32 1.42v-12.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1390.33 362.18l15.22 20.8-9.95-2.54-5.27 2.26v-20.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1390.33 355.43l12.83 17.53-8.39-2.14-4.44 1.9v-17.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1390.33 350.83l9.57 13.08-6.26-1.6-3.31 1.42v-12.9z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M910.66 345.17l.77 3.8h-3.19v-3.8h2.42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.82 345.17l-.77 3.8h3.19v-3.8h-2.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M908.24 325.69l-15.23 20.81 9.96-2.55 5.27 2.26v-20.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M908.24 318.94l-12.83 17.53 8.39-2.14 4.44 1.9v-17.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M908.24 314.35l-9.57 13.07 6.26-1.6 3.31 1.42v-12.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M908.24 325.7l15.23 20.8-9.96-2.54-5.27 2.25V325.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M908.24 318.95l12.83 17.53-8.39-2.15-4.44 1.9v-17.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M908.24 314.35l9.57 13.08-6.26-1.6-3.31 1.41v-12.89z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M668.31 319.77l.77 3.79h-3.19v-3.79h2.42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.48 319.77l-.77 3.79h3.18v-3.79h-2.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M665.89 300.28l-15.22 20.81 9.95-2.54 5.27 2.25v-20.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M665.89 293.53l-12.83 17.54 8.39-2.15 4.44 1.9v-17.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M665.89 288.94l-9.57 13.07 6.26-1.6 3.31 1.42v-12.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M665.89 300.29l15.23 20.8-9.95-2.54-5.28 2.26v-20.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M665.89 293.54l12.84 17.53-8.39-2.14-4.45 1.9v-17.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M665.89 288.94l9.57 13.08-6.25-1.6-3.32 1.42v-12.9z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M698.61 310.97l.76 3.79h-3.18v-3.79h2.42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.77 310.97l-.77 3.79h3.19v-3.79h-2.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M696.19 291.49l-15.23 20.81 9.96-2.55 5.27 2.26v-20.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M696.19 284.74l-12.83 17.53 8.39-2.14 4.44 1.9v-17.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M696.19 280.14l-9.57 13.08 6.26-1.6 3.31 1.42v-12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M696.19 291.49l15.22 20.81-9.95-2.55-5.27 2.26v-20.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M696.19 284.74l12.83 17.54-8.39-2.15-4.44 1.9v-17.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M696.19 280.15l9.57 13.07-6.26-1.6-3.31 1.42v-12.89z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveMountainPanorama);
export default __webpack_public_path__ + "static/media/waveMountainPanorama.d89f756a34204247e4140a5c58ff747a.svg";
export { ForwardRef as ReactComponent };